import type { ReactNode } from 'react';

export function HeroText(props: { children: ReactNode }) {
    return <p className="hero-text">{props.children}</p>;
}
